var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import * as firebase from 'firebase/app';
import { getFirebaseApp } from '../utils/firebase';
import 'firebase/auth';
import 'firebase/firestore';
import dayjs from 'dayjs';
import { useAuth } from './Auth';
export var useLoadObjects = function (mapBounds, user, filterOrigin, skip) {
    var _a = useState(), objects = _a[0], setObjects = _a[1];
    var _b = useState(null), commentsObj = _b[0], setCommentsObj = _b[1];
    var _c = useState(null), votesObj = _c[0], setVotesObj = _c[1];
    useEffect(function () {
        if (!mapBounds || skip) {
            setObjects(null);
            return;
        }
        setObjects(undefined);
        setCommentsObj(null);
        setVotesObj(null);
        var minLat = mapBounds.minLat, maxLat = mapBounds.maxLat, minLng = mapBounds.minLng, maxLng = mapBounds.maxLng;
        if (!minLat || !maxLat || !minLng || !maxLng) {
            console.log('Invalid map bounds:', mapBounds);
            return;
        }
        console.debug('Load by', mapBounds);
        var now = new Date().toISOString();
        // todo use geofirestore-js as it doesn't filter by longitude right now
        var ref = getFirebaseApp()
            .firestore()
            .collection('objects')
            // .where('valid_until', '>=', now)
            .where('loc', '>', new firebase.firestore.GeoPoint(minLat, minLng))
            .where('loc', '<', new firebase.firestore.GeoPoint(maxLat, maxLng));
        if (filterOrigin) {
            ref = ref.where('origin', '==', filterOrigin);
        }
        var unsub = ref.onSnapshot(function (snap) {
            var objs = snap.docs
                .filter(function (doc) {
                var _a;
                var valid_until = (_a = doc.data()) === null || _a === void 0 ? void 0 : _a.valid_until;
                return !!valid_until && valid_until >= now;
            })
                .map(function (doc) { return (__assign({ id: doc.id }, doc.data())); });
            console.debug('Loaded objects', objs);
            setObjects(objs);
        });
        return unsub;
    }, [mapBounds, filterOrigin]);
    useEffect(function () {
        if (!objects)
            return;
        var objectIds = objects.map(function (o) { return o.id; }).slice(0, 10); // TODO fix!!!
        console.debug('Load comments for', objectIds);
        if (!objectIds.length)
            return;
        var unsubComments = getFirebaseApp()
            .firestore()
            .collection('comments')
            .where('object_id', 'in', objectIds)
            .onSnapshot(function (snap) {
            var objs = {};
            snap.forEach(function (doc) {
                var comment = doc.data();
                comment.id = doc.id;
                var objComms = objs[comment.object_id] || [];
                objComms.push(comment);
                objs[comment.object_id] = objComms;
            });
            console.debug('Loaded comments', objs);
            setCommentsObj(objs);
        });
        var unsubVotes = getFirebaseApp()
            .firestore()
            .collection('votes')
            .where('object_id', 'in', objectIds)
            .onSnapshot(function (snap) {
            var objs = {};
            snap.forEach(function (doc) {
                var vote = doc.data();
                var objectVotingInfo = objs[vote.object_id] || {
                    votesCount: 0,
                    userVoted: false,
                };
                objectVotingInfo.votesCount += vote.value;
                if ((user === null || user === void 0 ? void 0 : user.uid) === vote.author) {
                    objectVotingInfo.userVoted = true;
                }
                objs[vote.object_id] = objectVotingInfo;
            });
            console.debug('Loaded votes', objs);
            setVotesObj(objs);
        });
        return function () {
            unsubComments();
            unsubVotes();
        };
    }, [mapBounds, objects, user]);
    var data = useMemo(function () {
        if (!objects || !commentsObj || !votesObj)
            return undefined;
        return objects.map(function (obj) { return (__assign(__assign(__assign({}, obj), { comments: commentsObj[obj.id] || [] }), (votesObj[obj.id] || { userVoted: false, votesCount: 0 }))); });
    }, [objects, commentsObj, votesObj]);
    return data;
};
export var useLoadSingleObject = function (id, user) {
    var _a = useState(), object = _a[0], setObject = _a[1];
    var _b = useState(null), comments = _b[0], setComments = _b[1];
    var _c = useState(null), votesInfo = _c[0], setVotesInfo = _c[1];
    useEffect(function () {
        console.debug('Load by id', id);
        setObject(undefined);
        setComments(null);
        setVotesInfo(null);
        var unsub = getFirebaseApp()
            .firestore()
            .collection('objects')
            .doc(id)
            .onSnapshot(function (doc) {
            if (!doc.exists) {
                setObject(null);
                console.log('object not found');
                return;
            }
            var objectInfo = __assign({ id: doc.id }, doc.data());
            console.debug('Loaded objects', objectInfo);
            setObject(objectInfo);
        });
        return unsub;
    }, [id]);
    useEffect(function () {
        console.debug('Load comments for', id);
        var unsubComments = getFirebaseApp()
            .firestore()
            .collection('comments')
            .where('object_id', '==', id)
            .orderBy('created')
            .onSnapshot(function (snap) {
            var comms = snap.docs.map(function (doc) {
                return __assign({ id: doc.id }, doc.data());
            });
            console.debug('Loaded comments', comms);
            setComments(comms);
        });
        var unsubVotes = getFirebaseApp()
            .firestore()
            .collection('votes')
            .where('object_id', '==', id)
            .onSnapshot(function (snap) {
            var objectVotingInfo = {
                votesCount: 0,
                userVoted: false,
            };
            snap.forEach(function (doc) {
                var vote = doc.data();
                objectVotingInfo.votesCount += vote.value;
                if ((user === null || user === void 0 ? void 0 : user.uid) === vote.author) {
                    objectVotingInfo.userVoted = true;
                }
            });
            console.debug('Loaded votes', objectVotingInfo);
            setVotesInfo(objectVotingInfo);
        });
        return function () {
            unsubComments();
            unsubVotes();
        };
    }, [id, user]);
    var data = useMemo(function () {
        if (!object || !comments || !votesInfo)
            return undefined;
        return __assign(__assign(__assign({}, object), { comments: comments }), votesInfo);
    }, [object, comments, votesInfo]);
    return data;
};
export var useAsyncStatus = function (cb) {
    var _a = useState({
        pending: false,
        success: false,
        error: '',
    }), status = _a[0], setStatus = _a[1];
    var ref = useRef(cb);
    ref.current = cb;
    var func = useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        setStatus(__assign(__assign({}, status), { pending: true, error: '' }));
        ref
            .current()
            .then(function (res) {
            setStatus(__assign(__assign({}, status), { pending: false, success: true }));
            return res;
        })
            .catch(function (err) {
            setStatus(__assign(__assign({}, status), { pending: false, error: err.toString() }));
        });
    }, [status]);
    return useMemo(function () { return ({ status: status, func: func }); }, [status, func]);
};
export var postObject = function (user, loc, item, origin) { return __awaiter(void 0, void 0, void 0, function () {
    var timenow;
    return __generator(this, function (_a) {
        if (!user || !loc) {
            alert('Temporary cannot post objects. Try again');
            throw new Error('Cannot post object');
        }
        timenow = new Date().toISOString();
        return [2 /*return*/, getFirebaseApp()
                .firestore()
                .collection('objects')
                .add(__assign(__assign({}, item), { author: user.uid, origin: origin || null, created: timenow, updated: timenow, loc: new firebase.firestore.GeoPoint(loc.latitude, loc.longitude) }))];
    });
}); };
export var closeObject = function (user, item) { return __awaiter(void 0, void 0, void 0, function () {
    var timenow;
    return __generator(this, function (_a) {
        if (!user) {
            alert('Temporary cannot close objects. Try again');
            throw new Error('Cannot close object');
        }
        timenow = new Date().toISOString();
        return [2 /*return*/, getFirebaseApp()
                .firestore()
                .collection('objects')
                .doc(item.id)
                .update({
                valid_until: dayjs().toISOString(),
                updated: timenow,
            })];
    });
}); };
export var voteUp = function (user, item) { return __awaiter(void 0, void 0, void 0, function () {
    var timenow;
    return __generator(this, function (_a) {
        if (!user) {
            alert('You need to register or sign in');
            throw new Error('Cannot vote');
        }
        timenow = new Date().toISOString();
        return [2 /*return*/, getFirebaseApp().firestore().collection('votes').add({
                object_id: item.id,
                author: user.uid,
                value: 1,
                created: timenow,
            })];
    });
}); };
export var leaveComment = function (user, item, comment) { return __awaiter(void 0, void 0, void 0, function () {
    var timenow;
    return __generator(this, function (_a) {
        if (!user) {
            alert('You need to register or sign in');
            throw new Error('Cannot vote');
        }
        timenow = new Date().toISOString();
        return [2 /*return*/, getFirebaseApp().firestore().collection('comments').add({
                object_id: item.id,
                author: user.uid,
                comment: comment,
                created: timenow,
            })];
    });
}); };
export var useUserPublicInfo = function (userId, subscribe) {
    if (subscribe === void 0) { subscribe = false; }
    var _a = useState(), object = _a[0], setObject = _a[1];
    useEffect(function () {
        console.debug('Load user id', userId);
        var ref = getFirebaseApp()
            .firestore()
            .collection('users-public')
            .doc(userId);
        if (subscribe) {
            var unsub = ref.onSnapshot(function (doc) {
                if (!doc.exists) {
                    setObject(null);
                    console.log('user not found');
                    return;
                }
                var objectInfo = __assign({ id: doc.id }, doc.data());
                console.debug('Loaded objects', objectInfo);
                setObject(objectInfo);
            });
            return unsub;
        }
        ref.get().then(function (doc) {
            var objectInfo = __assign({ id: doc.id }, doc.data());
            console.debug('Resolved once', objectInfo);
            setObject(objectInfo);
        });
    }, [userId, subscribe]);
    return object;
};
export var saveUserPublicInfo = function (userInfo) { return __awaiter(void 0, void 0, void 0, function () {
    var id, data, timenow;
    return __generator(this, function (_a) {
        id = userInfo.id, data = __rest(userInfo, ["id"]);
        timenow = new Date().toISOString();
        return [2 /*return*/, getFirebaseApp()
                .firestore()
                .collection('users-public')
                .doc(id)
                .set(__assign(__assign({}, data), { created: data.created || timenow, updated: timenow }))];
    });
}); };
export var useDirectMessage = function (dialogId) {
    var _a = useState(), dialogInfo = _a[0], setDialogInfo = _a[1];
    var _b = useState([]), messages = _b[0], setMessages = _b[1];
    var ref = useMemo(function () {
        return getFirebaseApp().firestore().collection('direct-messages').doc(dialogId);
    }, [dialogId]);
    var me = useAuth();
    var postMessage = useCallback(function (message) { return __awaiter(void 0, void 0, void 0, function () {
        var members, timestamp, msgDoc;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!me)
                        throw new Error('Not authenticated');
                    if (!!dialogInfo) return [3 /*break*/, 2];
                    members = dialogId.split('-');
                    return [4 /*yield*/, ref.set({
                            members: members,
                            created: new Date().toISOString(),
                        })];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2:
                    timestamp = new Date().toISOString();
                    return [4 /*yield*/, ref.collection('dm-items').add({
                            timestamp: timestamp,
                            author: me === null || me === void 0 ? void 0 : me.uid,
                            content: message,
                        })];
                case 3:
                    msgDoc = _b.sent();
                    return [2 /*return*/, ref.update((_a = {
                                updated: timestamp,
                                lastMsgId: msgDoc.id
                            },
                            _a["lastReadBy." + me.uid] = msgDoc.id,
                            _a))];
            }
        });
    }); }, [dialogInfo, dialogId, ref, me]);
    var updateLastMessageReadByMe = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            if (!me)
                throw new Error('Not authenticated');
            if (!dialogInfo) {
                return [2 /*return*/];
            }
            return [2 /*return*/, ref.update((_a = {},
                    _a["lastReadBy." + me.uid] = dialogInfo.lastMsgId,
                    _a))];
        });
    }); }, [dialogInfo, ref, me]);
    useEffect(function () {
        return ref.onSnapshot(function (doc) {
            if (!doc.exists) {
                setDialogInfo(null);
                return;
            }
            setDialogInfo(__assign({ id: dialogId }, doc.data()));
        }, function (err) { return console.log('Error loading dm-items', err); });
    }, [ref, dialogId]);
    var _c = useState(0), retryCounter = _c[0], setRetryCounter = _c[1];
    useEffect(function () {
        if (!dialogInfo)
            return;
        return ref
            .collection('dm-items')
            .orderBy('timestamp')
            .onSnapshot(function (snap) {
            var msgs = snap.docs.map(function (doc) {
                var _a = doc.data(), timestamp = _a.timestamp, author = _a.author, content = _a.content;
                return { id: doc.id, timestamp: timestamp, author: author, content: content };
            });
            setMessages(msgs);
        }, function (err) {
            // It can happen when sending first message, we create the info structure then post message to its subcollection
            // First attempt (right after info creation) fails
            if (retryCounter > 1)
                console.error(err);
            console.debug('Cannot load dm-items, retry in 1 sec');
            setTimeout(function () { return setRetryCounter(function (count) { return count + 1; }); }, 1000);
        });
    }, [ref, dialogId, dialogInfo, retryCounter]);
    return { info: dialogInfo, messages: messages, postMessage: postMessage, updateLastMessageReadByMe: updateLastMessageReadByMe };
};
export var useMyDirectMessages = function () {
    var _a = useState(null), dialogs = _a[0], setDialogs = _a[1];
    var me = useAuth();
    useEffect(function () {
        if (!me)
            return;
        return getFirebaseApp()
            .firestore()
            .collection('direct-messages')
            .where('members', 'array-contains', me.uid)
            .orderBy('updated', 'desc')
            .onSnapshot(function (snap) {
            setDialogs(snap.docs.map(function (doc) {
                return __assign({ id: doc.id }, doc.data());
            }));
        }, console.error);
    }, [me]);
    return { dialogs: dialogs };
};
//# sourceMappingURL=DB.js.map